<script setup lang="ts">

</script>

<template>
  <h1>Dashboard</h1>
</template>

<style scoped>

</style>